import type { Config } from 'tailwindcss'
import forms from '@tailwindcss/forms'

// declaring it first because VS Code flattens the symbols lookup
// [issue](https://github.com/microsoft/vscode/issues/195993)
const config = {
  content: [
    './src/**/*.{ts,tsx}',
    './node_modules/@jana-technology/*/dist/**/*.js',
    './public/index.html'
  ],
  theme: {
    colors: {
      transparent: 'transparent',
      current: 'currentColor',
      white: '#FFFFFF',
      black: '#231F20',
      blue: {
        DEFAULT: '#427EC3',
        700: '#0088C1',
        // This represents "blue-navy" with variants from Platform UI
        // These are flattened to conform to tailwind config type
        // Note that we use 1C355E instead of 1F355E from platform UI
        // as we used this as navy color in other places already
        navy: '#1C355E',
        'navy-500': '#1C355E' // Platform UI modal bg
      },
      lightBlue: {
        DEFAULT: '#21B3E8',
        100: '#90D9F3',
        300: '#64CAEF',
        500: '#3B82F6',
        600: '#1EA1D0',
        650: '#228FCE',
        700: '#1A8FBA'
      },
      lighthouseBlue: {
        DEFAULT: '#82ACFF',
        100: '#C0D5FF',
        300: '#A8C5FF',
        600: '#759BE5',
        700: '#688ACC'
      },
      // Lighthouse brand color from JANA product palette
      // The new lighthouse blue?
      lighthouse: {
        100: '#EBF1FF',
        300: '#C7DAFF',
        500: '#82ACFF', // DEFAULT
        700: '#6082CC'
      },
      green: {
        DEFAULT: '#4FBC8F',
        safe: '#14B025',
        100: '#A7DDC7',
        300: '#84D0B1',
        600: '#47A980',
        700: '#3F9773'
      },
      lime: {
        DEFAULT: '#83C341',
        100: '#C1E1A0',
        300: '#A9D57A',
        600: '#76AF3A',
        700: '#699C34'
      },
      orange: {
        DEFAULT: '#FFAF47',
        warn: '#F68121',
        100: '#FFD7A3',
        200: '#FFD87D',
        300: '#FFC77F',
        600: '#E59D40',
        700: '#CC8C39'
      },
      red: {
        DEFAULT: '#DD668A',
        danger: '#D01F31',
        100: '#EEB3C4',
        300: '#E894AD',
        600: '#C75C7C',
        700: '#B1526F',
        800: '#B70000'
      },
      gray: {
        100: '#F2F3F4',
        // REVIEW: Deprecate 200?
        200: '#E4E5E6',
        300: '#D1D3D4',
        400: '#D3D3D3',
        500: '#A7A9AC',
        700: '#808285',
        900: '#58595B'
      },
      // Platform UI naming: gray -> grey
      grey: {
        100: '#F2F3F4',
        300: '#D1D3D4',
        500: '#A7A9AC',
        700: '#808285',
        900: '#58595B'
      },
      yellow: {
        100: '#FBDD0B'
      }
    },
    fontSize: {
      xs: '10px',
      sm: '12px',
      base: '14px',
      lg: '16px',
      xl: '18px',
      '2xl': '20px',
      '3xl': '24px',
      '4xl': '30px',
      '5xl': '36px',
      '6xl': '48px',
      '7xl': '60px',
      '8xl': '72px'
    },
    extend: {
      maxHeight: {
        60: '15rem',
        100: '25rem',
        120: '30rem',
        '48vh': '48vh',
        '64vh': '64vh',
        '72vh': '72vh',
        '96vh': '96vh'
      },
      minHeight: {
        20: '5rem',
        '25vh': '25vh',
        '50vh': '50vh'
      },
      minWidth: {
        50: '12.5rem',
        100: '25rem',
        320: '80rem',
        '50vw': '50vw'
      },
      width: {
        120: '30rem',
        128: '32rem',
        144: '36rem',
        256: '64rem'
      },
      flex: {
        2: '2 2 0%',
        3: '3 3 0%'
      },
      flexShrink: {
        2: '2',
        3: '3'
      },
      boxShadow: {
        'modal-box-shadow': '0 4px 16px 0 rgba(35, 31, 32, 0.3)',
        'upload-file-shadow': '0px 2px 4px 0 rgba(35, 31, 32, 0.12)'
      }
    },
    fontFamily: {
      base: [
        'Inter Variable, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol'
      ]
    }
  },
  plugins: [forms]
}

export default config satisfies Config
